'use strict';

(function (global) {

  // 352px - ширина области комментариев
  const commentAreaWidth = 352;

  /**
   * Действия над текстовым документом.
   * (Масштабирование)
   */
  class TextActions extends global.BaseActions {

    constructor(context) {
      super();
      this._settings = new global.TextDocumentPreviewSettings();
      this._initAttributes(context);
    }

    /**
     * @see Core.preview.BaseActions._initAttributes
     */
    _initAttributes(context) {
      super._initAttributes(context);
      this._body = this._jFrameContents.find('body');      

      let contentGenerator = this._body.find('meta[name = Generator]').attr('content');
      if ((!!contentGenerator) && (contentGenerator.startsWith('Microsoft Word'))) {
        this._body.addClass('plaintext-document');
      }
    }

    /**
     * Масштабирование контента.
     *
     * @method _zoom
     * @param {number} zoomValue Коэфициент масштабирования.
     * @private
     */
    _zoom(zoomValue) {
      const jScaledContent = this._body.find('.text-document-container__scaled-content');
      jScaledContent.css({
        transform: `scale(${zoomValue})`,
      });

      requestAnimationFrame(() => {
        const marginTop = Math.floor(jScaledContent.outerHeight() * (zoomValue - 1));
        jScaledContent.css({
          marginTop: `${marginTop}px`,
        });
      });

      this._zoomValue = zoomValue;
      this.movePreview();
    }

    /**
     * @see BaseActions.onResize
     */
    onResize() {
      this.setScale();
    }

    /**
     * @see BaseActions.movePreview
     */
    movePreview() {
      const sourceWidth = this._body.find('.text-document-container').prop('clientWidth');
      const jContentContainer = this._body.find('.text-document-container__scaled-content');
      let maxPageWidth = 0;

      const jWordDocumentPages = this._body.find('.word-document-page__main-content');
      if (jWordDocumentPages.length) {
        jWordDocumentPages.each((index, domElement) => {
          try {
            const commentsWidth = this._settings.commentsVisibility ? commentAreaWidth : 0;
            const jCurrentPage = $(domElement);
            const currentPageWidth = commentsWidth + jCurrentPage.outerWidth();
            if (currentPageWidth > maxPageWidth) {
              maxPageWidth = currentPageWidth;
            }
          } catch (err) {
            console.warn(err);
          }          
        });
      } else {
        // Сделано для того, чтобы текстовые документы при увеличении масштаба не увеличивались в ширину.
        jContentContainer.css({
          left: 0,
        });
        maxPageWidth = jContentContainer.children().outerWidth();
      }

      const left = (sourceWidth - maxPageWidth * this._zoomValue) / 2;
      if (left > 0) {
        jContentContainer.css({
          left: left,
        });
      } else {
        jContentContainer.css({
          left: 0,
        });
      }
    }

    /**
     * Установить масштаб.
     * Возможные значения:
     * - число;
     * - 'w' - подбор по ширине отображаемых страниц.
     * @see Core.preview.BaseActions.setScale
     */
    setScale(key = this._settings.previewScale) {
      super.setScale(key);
      this._setScaleValueInDropdown(key);

      requestAnimationFrame(() => {
        if (key === 'w') {
          // Определить, насколько прокручен viewport
          const viewportTop = this._body.find('.text-document-container').scrollTop();
          const viewportBottom = viewportTop + this._jFrame.height();

          // Получить список видимых страниц
          requestAnimationFrame(() => {
            let documentWidth = 0;
            const viewportWidth = this._jFrame.innerWidth();
            this._body.find('.text-document-container__scaled-content').children().each((index, element) => {
              const jDocumentPage = $(element);

              const jPageTop = jDocumentPage.position().top;
              const jPageBottom = jPageTop + jDocumentPage.height();

              if (jPageBottom > viewportTop && jPageTop < viewportBottom) {
                // Просуммировать ширины дочерних элементов
                let pageWidth = 32;

                const jWordDocumentPages = jDocumentPage.children('.word-document-page__main-content');
                if (jWordDocumentPages.length) {
                  if (this.settings.commentsVisibility) {
                    pageWidth += commentAreaWidth;
                  }
                  pageWidth += jWordDocumentPages.outerWidth();
                  if (pageWidth > documentWidth) {
                    documentWidth = pageWidth;
                  }

                } else {
                  pageWidth += jDocumentPage.outerWidth();
                  // 16px -- резерв для вертикального скроллбара
                  documentWidth = Math.max(pageWidth, viewportWidth + 16);
                }
              }
            });

            // Получить ширину viewport'а
            const zoomValue = Math.floor(viewportWidth / documentWidth * 100) / 100;
            this._zoom(zoomValue);
          });

        } else {
          // Получить масштаб
          const zoomValue = +key / 100;
          requestAnimationFrame(() => {
            this._zoom(zoomValue);
          });
        }
      });
    }
  }

  global.TextActions = TextActions;

})(window.Core.preview);